import { render, staticRenderFns } from "./Professores.vue?vue&type=template&id=c40098c2"
import script from "./Professores.vue?vue&type=script&lang=js"
export * from "./Professores.vue?vue&type=script&lang=js"
import style0 from "./Professores.vue?vue&type=style&index=0&id=c40098c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports